import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";

UIkit.use(Icons);



UIkit.util.on('#drop', 'shown', function () {
    console.log('drop show');
    // do something
});

export default UIkit;


